<template>
	<v-dialog
		v-model="show"
		@keydown.esc="hideDialog()"
		v-on="show ? { 'click:outside' : hideDialog } : ''"
		persistent
		scrollable
		width="727px"
	>
		<v-card flat outlined class="wall-card">
			<v-card-title class="d-flex justify-content-between align-center">
				<div>{{ $vuetify.lang.t('$vuetify.views.group.dialogs.inviteMembers.header') }}</div>
				<v-btn icon @click="hideDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col>
						<search v-model="search" />
						<template v-if="!sending">
							<div
								v-for="(user, i) in users"
								:key="'user-to-invite-' + i"
								class="mt-5 d-flex"
							>
								<div class="d-flex align-center">
									<v-checkbox
										class="mt-0 pt-0"
										v-model="checkedUsers"
										:value="user"
										hide-details
										:ripple="false"
									></v-checkbox>
								</div>
								<div>
									<avatar :user="user" />
								</div>
								<div class="pl-2">
									<div class="text--darken-2 grey--text font-weight-bold" v-if="user.name">{{ user.name }}</div>
									<div class="font-12 grey--text mt-1">Team</div>
								</div>
							</div>
						</template>
					</v-col>
					<v-col class="border-left" v-if="checkedUsers.length > 0">
						<div class="d-flex">
							<div class="text--darken-2 grey--text font-weight-bold">Wybrano</div>
							<div class="accent lighten-1 accent--text font-weight-bold rounded-xl ml-2" style="padding: 0 6px;">{{ checkedUsers.length }}</div>
						</div>
						<div
							v-for="(user, i) in checkedUsers"
							:key="'checked-user-to-invite-' + i"
							class="mt-5 d-flex"
						>
							<div>
								<avatar :user="user" />
							</div>
							<div class="pl-2">
								<div class="text--darken-2 grey--text font-weight-bold" v-if="user.name">{{ user.name }}</div>
								<div class="font-12 grey--text mt-1">Team</div>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="d-flex justify-end pb-5">
				<v-btn
					color="grey lighten-2"
					elevation="0"
					@click="hideDialog()"
				>{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn
					color="accent"
					elevation="0"
					@click="sendData()"
				>{{ $vuetify.lang.t('$vuetify.views.group.dialogs.inviteMembers.invite') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Search from "@/components/top-bar/Search";
import {mapActions, mapGetters} from "vuex";
import Avatar from "@/components/Avatar";
export default {
	name: "GroupInviteDialog",
	components: {
		Search,
		Avatar,
	},
	props: {
		group: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			show: false,
			search: '',
			checkedUsers: [],
			sending: false,
			delay: 0
		}
	},
	watch: {
		search: function (v) {
			if (this.delayer) {
				clearTimeout(this.delayer)
				this.delayer = null
			}
			this.delayer = setTimeout(async () => {
				this.sending = true
				await this.getUsersToInvite({ group: this.group, params : { name: v } })
				this.sending = false
				this.delay = 500
			}, this.delay)
		}
	},
	computed: {
		...mapGetters({
			users: "groups/usersToInvite",
		}),
	},
	methods: {
		...mapActions('groups', [
			'getUsersToInvite',
			'inviteUsersToGroup'
		]),
		showDialog() {
			this.checkedUsers = []
			this.show = true
		},
		hideDialog() {
			this.show = false
			this.checkedUsers = []
			this.search = ''
		},
		async sendData() {
			let users = []
			for (let i in this.checkedUsers) {
				users.push(this.checkedUsers[i].id)
			}
			if (await this.inviteUsersToGroup({ users }))
				this.hideDialog()
		}
	}
}
</script>
